import React from 'react';

const StatusPill = ({ status }) => {
  const map = {
    active: 'bg-emerald-500/15 text-emerald-200 border-emerald-400/30',
    blocked: 'bg-rose-500/15 text-rose-200 border-rose-400/30',
    'not approved': 'bg-amber-500/15 text-amber-200 border-amber-400/40',
    pending: 'bg-cyan-500/15 text-cyan-100 border-cyan-400/30',
  };
  return (
    <span className={`text-[11px] px-3 py-1 rounded-full border ${map[status?.toLowerCase()] || map.pending}`}>
      {status}
    </span>
  );
};
export default StatusPill